class Core {
    constructor() {
        this.managers = [];
    }

    setStore(store) {
        this.store = store;
    }

    addManager(manager) {
        manager.core = this;
        this.managers.push(manager);
    }

    setCacheManager(manager) {
        this.cacheManager = manager;
        this.addManager(manager);
    }

    setCustomEventsManager(manager) {
        this.customEventsManager = manager;
        this.addManager(manager);
    }

    setCustomCodesManager(manager) {
        this.customCodesManager = manager;
        this.addManager(manager);
    }

    setImplementationManager(manager) {
        this.implementationManager = manager;
        this.addManager(manager);
    }

    setAuthenticationManager(manager) {
        this.authenticationManager = manager;
        this.addManager(manager);
    }

    setLiteralsManager(manager) {
        this.literalsManager = manager;
        this.addManager(manager);
    }

    setSandboxManager(manager) {
        this.sandboxManager = manager;
        this.addManager(manager);
    }

    setRolesManager(manager) {
        this.rolesManager = manager;
        this.addManager(manager);
    }

    setSearchManager(manager) {
        this.searchManager = manager;
        this.addManager(manager);
    }

    setSectionManager(manager) {
        this.sectionManager = manager;
        this.addManager(manager);
    }

    setServerListManager(manager) {
        this.serverListManager = manager;
        this.addManager(manager);
    }

    setUsersManager(manager) {
        this.usersManager = manager;
        this.addManager(manager);
    }

    setApiKeysManager(manager) {
        this.apiKeysManager = manager;
        this.addManager(manager);
    }

    setPermissionsManager(manager) {
        this.permissionsManager = manager;
        this.addManager(manager);
    }

    setDeviceCacheManager(manager) {
        this.deviceCacheManager = manager;
        this.addManager(manager);
    }
}

const CoreSingleton = (function coresingleton() {
    let instance;

    function createInstance() {
        const object = new Core();
        return object;
    }

    return {
        getInstance() {
            if (!instance) {
                instance = createInstance();
            }
            return instance;
        },
    };
})();

export default CoreSingleton.getInstance();
